export function gmailThreadLink(threadId: string, accountEmail: string): string {
  return `https://mail.google.com/mail/?authuser=${encodeURIComponent(accountEmail)}#all/${encodeURIComponent(threadId)}`;
}

export function gmailMailboxThreadLink(threadId: string, accountEmail: string, labelIds: string[]): string {
  const mailbox = labelIds.includes('TRASH') ? 'trash' : labelIds.includes('SPAM') ? 'spam' : 'all';
  return `https://mail.google.com/mail/?authuser=${encodeURIComponent(accountEmail)}#${mailbox}/${encodeURIComponent(threadId)}`;
}

interface GmailSearchFallback {
  subject?: string;
  senderEmail?: string;
}

function gmailSearchUrl(query: string, accountEmail: string): string {
  return `https://mail.google.com/mail/?authuser=${encodeURIComponent(accountEmail)}#search/${encodeURIComponent(query)}`;
}

function quotedSearchPhrase(value: string): string {
  return value.replace(/["\\]/g, ' ').replace(/\s+/g, ' ').trim();
}

export function gmailMessageSearchLink(
  rfcMessageId: string,
  accountEmail: string,
  fallbackThreadId = '',
  fallback: GmailSearchFallback = {},
): string {
  const normalized = rfcMessageId.trim().replace(/^<|>$/g, '');
  if (normalized) return gmailSearchUrl(`in:anywhere rfc822msgid:${normalized}`, accountEmail);

  const subject = quotedSearchPhrase(fallback.subject ?? '');
  const senderEmail = fallback.senderEmail?.trim() ?? '';
  if (subject && senderEmail) {
    return gmailSearchUrl(`in:anywhere -in:drafts -in:sent from:${senderEmail} subject:"${subject}"`, accountEmail);
  }

  return gmailThreadLink(fallbackThreadId, accountEmail);
}

export function sourceMailResolverLink(messageId: string): string {
  return `/source-mail/${encodeURIComponent(messageId)}`;
}

export function sourceMailFallbackLink(messageId: string, subject: string, sender: string, threadId: string): string {
  const path = `/api/gmail/messages/${encodeURIComponent(messageId)}/open`;
  const query = new URLSearchParams({ thread: threadId, subject, sender }).toString();
  return query ? `${path}?${query}` : path;
}
